import { StandardTextFieldProps, TextField } from '@mui/material';

export const ReadOnlyTextField = (props: StandardTextFieldProps) => (
  <TextField InputProps={{ readOnly: true }} variant={'standard'} fullWidth sx={{ my: 2, ...props.sx }} {...props}/>);